import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Container, Grid, Box } from '@mui/material';
import './dashboard.scss';

export default function SupportDashboard() {
  const navigate = useNavigate();
  return (
    <Container sx={{ p: 4, minHeight: '100vh' }}>
      <Button
        sx={{
          mb: 2,
          color: 'primary.main',
          '&:hover': { bgcolor: 'grey.200' },
        }}
        variant="text"
        onClick={() => {
          navigate('/help-center');
        }}
      >
        <span>← Back</span>
      </Button>
      <div className="help__center__container" lang="en">
        <Box sx={{ mb: 4 }}>
          <Grid container spacing={2}>
            <Grid item>
              <Button variant="contained" href="/help-center/dashboard">
                Overview
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/building">
                Building
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/devices">
                Devices
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/settings">
                Settings
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/map">
                Map
              </Button>
            </Grid>
          </Grid>
        </Box>

        <div className="dashboard__component__guide">
          <h2>EOS Overview Guide</h2>

          <div className="content__box">
            <img src="/helpcenter/overview.png" alt="Overview" />
          </div>

          <div id="building-card" className="content__box">
            <img src="/helpcenter/building.png" alt="Building Overview" />
            <p>
              <strong>Building:</strong> Shows which building you are
              monitoring. In this case, it’s <em>New Building</em>. If vendor
              has more than one building then a dropdown with a list of
              buildings will be shown.
            </p>
          </div>

          <div className="content__box">
            <img src="/helpcenter/outdoor-temp.png" alt="Outdoor Temperature" />
            <p>
              <strong>Outdoor Temperature:</strong> Displays current external
              temperature with trend arrows. (e.g., 14.6°C ↓) The arrow
              indicates whether the temperature is above or below the average.
              All temperature data is provided by the Norwegian Meteorological
              Institute.
            </p>
          </div>

          <div className="content__box">
            <img src="/helpcenter/co2-footprint.png" alt="CO2 Footprint" />
            <p>
              <strong>CO₂ Footprint Reduction:</strong> Shows current and
              reduced carbon emissions. (e.g., 554 (280) kg CO₂ ↓)
            </p>
          </div>

          <div className="content__box">
            <img
              src="/helpcenter/price-summary.png"
              alt="Electricity Prices Summary"
            />
            <p>
              <strong>Electricity Prices:</strong> Displays price per kWh with
              change indicator. (e.g., 62 øre/kWh ↓)
            </p>
          </div>

          <div className="content__box">
            <img
              src="/helpcenter/consumption-summary.png"
              alt="Electricity Consumption Summary"
            />
            <p>
              <strong>Consumption:</strong> Today and yesterday electricity
              usage comparison. (e.g., 1877 kWh / 2826 kWh)
            </p>
          </div>

          <div className="content__box">
            <img src="/helpcenter/weather.png" alt="Weather Forecast" />
            <p>
              <strong>Weather Forecast:</strong> Temperature trends with
              min/avg/max over time.
            </p>
          </div>

          <div className="content__box">
            <img
              src="/helpcenter/prices-graph.png"
              alt="Electricity Prices Graph"
            />
            <p>
              <strong>Electricity Prices (Graph):</strong> Visual representation
              of hourly energy cost. Helps plan usage around lower-cost periods.
            </p>
          </div>

          <div className="content__box">
            <img src="/helpcenter/sankey.png" alt="EOS Sankey Diagram" />
            <p>
              <strong>EOS Sankey Diagram:</strong> Shows energy distribution per
              unit/device, fed by HAN port data.
            </p>
          </div>
          <div className="content__box">
            <img src="/helpcenter/mindmap.png" alt="Mindmap" />
            <p>
              <strong>Mindmap:</strong> Click and drag to rotate the chart.
            </p>
          </div>

          <div className="content__box">
            <img
              src="/helpcenter/consumption.png"
              alt="Electricity Consumption Chart"
            />
            <p>
              <strong>Electricity Consumption (Chart):</strong> Active energy
              consumption history over selected range. Useful for identifying
              usage patterns.
            </p>
          </div>
          <div className="content__box">
            <img src="/helpcenter/reactive.png" alt="Subscriptions" />
            <p>
              <strong>Subscriptions:</strong> If your Elhub subscriptions are
              active, charts will appear in the EOS dashboard.
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
}
